import React, { useState } from "react";
import Button from "../Shared/Buttons/Button";
import { ArrowUturnLeftIcon } from "@heroicons/react/24/outline";
import { apiRequest } from "src/async/apiUtils";
import { objectToFormData } from "src/helpers";
import { toast } from "react-toastify";

const FreePlanConfirmation = ({ formData, onHandleChange, setView }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onHandleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const { data } = await apiRequest(
        "POST",
        "/self-setup",
        {
          body: objectToFormData({ ...formData, plan: formData?.plan?._id }),
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      onHandleChange("domain", data?.data?.domain);
      setView("setupProgress");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button
        version="secondary"
        className="mb-2"
        disabled={isSubmitting}
        onClick={() => setView("choosePlan")}>
        <ArrowUturnLeftIcon className="h-6 w-6" />
        Go back
      </Button>
      
      <div className="mt-4">
        <div className="flex w-full items-center gap-3 space-x-2 text-3xl font-semibold">{formData?.plan?.name || "Free Plan"}</div>
        <div
          dangerouslySetInnerHTML={{ __html: formData?.plan?.description }}
          className="ql-editor py-1 pl-0.5 text-sm opacity-75"></div>
      </div>

      <div className="mt-6 space-y-2 rounded-md border border-gray-200 bg-gray-50 p-6">
        <div className="flex items-center justify-between text-lg text-gray-700">
          <span className="font-semibold">Selected Plan:</span>
          <span>{formData?.plan?.name}</span>
        </div>
        <div className="flex items-center justify-between text-lg text-gray-700">
          <span className="font-semibold">Total Cost:</span>
          <span className="font-bold text-highlightColor">Free</span>
        </div>
        <p className="pt-4 text-sm text-gray-500">
          You have selected a free plan. No payment information is required to set up your instance. Click below to complete your registration.
        </p>
      </div>

      <div className="relative flex items-center justify-center gap-2 mt-8">
        <Button
          version="primary"
          className="!w-full"
          disabled={isSubmitting}
          loading={isSubmitting}
          onClick={onHandleSubmit}>
          Confirm and Setup
        </Button>
      </div>
    </>
  );
};

export default FreePlanConfirmation;
